import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import UploadButton from '../../../../../components/common/UploadButton';

const { Title } = Typography;

const Step3MechanicalExteriorForm = ({ fileList, setFileList }) => {
  const blockInvalidNumberKeys = (e) => {
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };
  // Dropdown options for different field types
  const yesNoOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' }
  ];

  const okRepairedOptions = [
    { value: 'Ok', label: 'Ok' },
    { value: 'Repaired', label: 'Repaired' }
  ];

  const okNotOkOptions = [
    { value: 'Ok', label: 'Ok' },
    { value: 'Not Ok', label: 'Not Ok' }
  ];

  const paintOptions = [
    { value: 'Ok', label: 'Ok' },
    { value: 'Scratch', label: 'Scratch' },
    { value: 'Dent', label: 'Dent' },
    { value: 'Scratch+Dent', label: 'Scratch+Dent' },
    { value: 'Painting Required', label: 'Painting Required' },
    { value: 'Repair Marks', label: 'Repair Marks' },
    { value: 'Rust', label: 'Rust' },
    { value: 'Scratch on Glass', label: 'Scratch on Glass' },
    { value: 'To be Replaced', label: 'To be Replaced' }
  ];


  // Render field with conditional cost and file - Optimized for compact layout
  const renderConditionalField = (fieldName, label, options, required = false, showFile = true, defaultValue = undefined) => (
    <Col xl={8} lg={12} md={24} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          rules={required ? [{ required: true, message: `Please select ${label}` }] : []}
          initialValue={defaultValue !== undefined ? defaultValue : (['clutch_defect', 'shift_shock_time_lag', 'gearbox_defect', 'wheel_noise_defect','steering_noise', 'jammed_steering','rh_rocker_panel','lh_rocker_panel','rh_rear_fender_panel','lh_rear_fender_panel','end_panel','jack_tools_kit','jack_tools_kit', 'door_lock_defect', 'periodic_service', 'carpet_upholstery','spare_keys', 'legal_case_resolution','original_accessories', 'spare_wheels','front_bumper', 'grill','rear_bumper','head_light', 'tail_light','fog_lamp', 'side_mirror','windshield_glass'].includes(fieldName) ? undefined : (options.length === 2 && options[0].value === 'Yes' ? 'No' : undefined))}
          style={{ marginBottom: '8px' }}
        >
          <Select className='form-control-ant' placeholder='Select Status' size='small'>
            {options.map(option => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {/* Conditional Cost and File Fields - Display below dropdown in same container */}
        <Form.Item dependencies={[fieldName]} noStyle>
          {({ getFieldValue }) => {
            const fieldValue = getFieldValue(fieldName);
            let shouldShow = false;

            // Determine if cost/file fields should be shown based on field value
            if (fieldName === 'jack_tools_kit' || fieldName === 'door_lock_defect' || 
                fieldName === 'periodic_service' || fieldName === 'carpet_upholstery' || 
                fieldName === 'spare_keys' || fieldName === 'legal_case_resolution' || 
                fieldName === 'original_accessories') {
              // Accessories and Tools fields: show cost/file when "No" is selected
              shouldShow = fieldValue === 'No';
            } else if (fieldName === 'exterior_front_paint' || fieldName === 'exterior_left_paint' || 
                       fieldName === 'exterior_right_paint' || fieldName === 'exterior_rear_paint' || 
                       fieldName === 'exterior_top_paint') {
              // Paint fields should show cost/file when not "Ok"
              shouldShow = fieldValue && fieldValue !== 'Ok';
            } else if (fieldName === 'rh_rocker_panel' || fieldName === 'lh_rocker_panel' || 
                       fieldName === 'rh_rear_fender_panel' || fieldName === 'lh_rear_fender_panel' || 
                       fieldName === 'end_panel') {
              // Body panel fields should show cost/file when "Repaired" is selected (not when "Ok")
              shouldShow = fieldValue === 'Repaired';
            } else if (fieldName === 'front_spoiler' || fieldName === 'front_bumper' || 
                       fieldName === 'grill' || fieldName === 'rear_bumper' || 
                       fieldName === 'rear_spoiler' || fieldName === 'head_light' || 
                       fieldName === 'tail_light' || fieldName === 'fog_lamp' || 
                       fieldName === 'side_mirror' || fieldName === 'mud_flap' || 
                       fieldName === 'windshield_glass' || fieldName === 'wheel_cover' || 
                       fieldName === 'weather_strip' || fieldName === 'logo_missing') {
              // Exterior component fields should show cost/file when "Not Ok" is selected (not when "Ok")
              shouldShow = fieldValue === 'Not Ok';
            } else {
              // Default for Yes/No fields: show only when "Yes" is selected
              shouldShow = fieldValue === 'Yes';
            }

            return shouldShow ? (
              <Row gutter={[8, 0]}>
                <Col span={showFile ? 12 : 24}>
                  <Form.Item
                    label={<span style={{ fontSize: '11px' }}>Cost</span>}
                    name={`${fieldName}_cost`}
                    initialValue={0}
                    rules={[
                      {
                        required: true,
                        message: `Please input ${label.toLowerCase()} cost`,
                      },
                      () => ({
                        validator(_, value) {
                          if (value && !/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                            return Promise.reject('Please enter a valid cost');
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                    style={{ marginBottom: '0' }}
                  >
                    <Input placeholder='Cost' className='form-control-ant' type='number' size='small' onKeyDown={blockInvalidNumberKeys} />
                  </Form.Item>
                </Col>
                {showFile && (
                  <Col span={12}>
                    <Form.Item
                      label={<span style={{ fontSize: '11px' }}>File</span>}
                      name={`${fieldName}_file`}
                      rules={[
                        {
                          required: true,
                          message: `Please upload ${label.toLowerCase()} file`,
                          validator: () => {
                            // Check if file exists in fileList
                            if (fileList[`${fieldName}_file`] && fileList[`${fieldName}_file`].length > 0) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(`Please upload ${label.toLowerCase()} file`));
                          }
                        },
                      ]}
                      style={{ marginBottom: '0' }}
                    >
                      <UploadButton 
                        name={`${fieldName}_file`} 
                        fileList={fileList} 
                        setFileList={setFileList} 
                        fileType={['image/jpeg', 'image/png']} 
                        fileSizeLimit={5} 
                        documentType={`${fieldName}_file`} 
                        hideDeleteIcon={true}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            ) : null;
          }}
        </Form.Item>
      </div>
    </Col>
  );

  // Special renderer for tyre percentage fields with cost and file
  const renderTyreField = (fieldName, label, required = false) => (
    <Col xl={8} lg={12} md={24} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          rules={[
            ...(required ? [{ required: true, message: `Please enter ${label} percentage` }] : []),
            {
              validator(_, value) {
                if (!value) {
                  return Promise.resolve();
                }
                const numValue = Number(value);
                if (isNaN(numValue)) {
                  return Promise.reject('Please enter a valid number');
                }
                if (numValue < 0) {
                  return Promise.reject('Percentage cannot be negative');
                }
                if (numValue > 100) {
                  return Promise.reject('Percentage cannot be more than 100%');
                }
                return Promise.resolve();
              },
            },
          ]}
          style={{ marginBottom: '8px' }}
        >
          <Input 
            className='form-control-ant' 
            placeholder='Enter % (0-100)' 
            type='number'
            min={0}
            max={100}
            size='small'
            addonAfter='%'
            onKeyDown={blockInvalidNumberKeys}
          />
        </Form.Item>

        {/* Cost and File Fields - Always required for tyres */}
        <Row gutter={[8, 0]}>
          <Col span={12}>
            <Form.Item
              label={<span style={{ fontSize: '11px' }}>Cost</span>}
              name={`${fieldName}_cost`}
              initialValue={0}
              rules={[
                {
                  required: true,
                  message: `Please input ${label.toLowerCase()} cost`,
                },
                () => ({
                  validator(_, value) {
                    if (value && !/^\d{1,10}(\.\d{1,2})?$/.test(value)) {
                      return Promise.reject('Please enter a valid cost');
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              style={{ marginBottom: '0' }}
            >
              <Input placeholder='Cost' className='form-control-ant' type='number' size='small' onKeyDown={blockInvalidNumberKeys} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={<span style={{ fontSize: '11px' }}>File</span>}
              name={`${fieldName}_file`}
              rules={[
                {
                  required: true,
                  message: `Please upload ${label.toLowerCase()} file`,
                  validator: () => {
                    // Check if file exists in fileList
                    if (fileList[`${fieldName}_file`] && fileList[`${fieldName}_file`].length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(`Please upload ${label.toLowerCase()} file`));
                  }
                },
              ]}
              style={{ marginBottom: '0' }}
            >
              <UploadButton 
                name={`${fieldName}_file`} 
                fileList={fileList} 
                setFileList={setFileList} 
                fileType={['image/jpeg', 'image/png']} 
                fileSizeLimit={5} 
                documentType={`${fieldName}_file`} 
                hideDeleteIcon={true}
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Col>
  );

  // Special renderer for textarea field
  const renderTextAreaField = (fieldName, label, required = false) => (
    <Col xl={24} lg={24} md={24} sm={24} xs={24} className='mb-2'>
      <div style={{ border: '1px solid #f0f0f0', borderRadius: '6px', padding: '12px', backgroundColor: '#fafafa' }}>
        <Form.Item
          label={<span style={{ fontSize: '12px', fontWeight: '500' }}>{label}</span>}
          name={fieldName}
          rules={required ? [{ required: true, message: `Please enter ${label}` }] : []}
          style={{ marginBottom: '0' }}
        >
          <Input.TextArea 
            placeholder='Enter other observations' 
            className='form-control-ant' 
            rows={4}
            size='small'
          />
        </Form.Item>
      </div>
    </Col>
  );

  return (
    <div>
      <Title level={4} className='mb-3'>Mechanical and Exterior Details</Title>
      
      {/* Transmission and Drivetrain */}
      <Title level={5} className='mb-3'>Transmission and Drivetrain</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('clutch_defect', 'Clutch Defect', yesNoOptions, true, true)}
        {renderConditionalField('transmission_oil_leak', 'Transmission Oil Leak', yesNoOptions, false, true)}
        {renderConditionalField('shift_shock_time_lag', 'Shift Shock Time Lag', yesNoOptions, true, true)}
        {renderConditionalField('gearbox_defect', 'GearBox Defect', yesNoOptions, true, true)}
        {renderConditionalField('drive_shaft_defect', 'Drive Shaft Defect', yesNoOptions, false, true)}
        {renderConditionalField('boot_cut', 'Boot Cut', yesNoOptions, false, true)}
        {renderConditionalField('differential_noise', 'Differential Noise', yesNoOptions, false, true)}
        {renderConditionalField('wheel_noise_defect', 'Wheel Noise Defect', yesNoOptions, true, true)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Suspension and Steering */}
      <Title level={5} className='mb-3'>Suspension and Steering</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('modified_suspension', 'Modified Suspension', yesNoOptions, false, true)}
        {renderConditionalField('steering_noise', 'Steering Noise', yesNoOptions, true, true)}
        {renderConditionalField('steering_oil_leak', 'Steering Oil Leak', yesNoOptions, false, true)}
        {renderConditionalField('steering_shaft_boot_cut', 'Steering Shaft Boot Cut', yesNoOptions, false, true)}
        {renderConditionalField('jammed_steering', 'Jammed Steering', yesNoOptions, true, true)}
        {renderConditionalField('defective_telescopic_tilt', 'Defective Telescopic Tilt', yesNoOptions, true, true)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Body Panels */}
      <Title level={5} className='mb-3'>Body Panels</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('rh_rocker_panel', 'RH Rocker Panel', okRepairedOptions, true, true)}
        {renderConditionalField('lh_rocker_panel', 'LH Rocker Panel', okRepairedOptions, true, true)}
        {renderConditionalField('rh_rear_fender_panel', 'RH Rear Fender Panel', okRepairedOptions, true, true)}
        {renderConditionalField('lh_rear_fender_panel', 'LH Rear Fender Panel', okRepairedOptions, true, true)}
        {renderConditionalField('end_panel', 'End Panel', okRepairedOptions, true, true)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Accessories and Tools */}
      <Title level={5} className='mb-3'>Accessories and Tools</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('jack_tools_kit', 'Jack Tools Kit', yesNoOptions, true, true)}
        {renderConditionalField('door_lock_defect', 'Door Lock Defect', yesNoOptions, true, true)}
        {renderConditionalField('periodic_service', 'Periodic Service', yesNoOptions, true, true)}
        {renderConditionalField('carpet_upholstery', 'Carpet Upholstery', yesNoOptions, true, true)}
        {renderConditionalField('spare_keys', 'Spare Keys', yesNoOptions, true, true)}
        {renderConditionalField('legal_case_resolution', 'Legal Case Resolution', yesNoOptions, true, true)}
        {renderConditionalField('original_accessories', 'Original Accessories', yesNoOptions, true, true)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Tyres and Wheels */}
      <Title level={5} className='mb-3'>Tyres and Wheels</Title>
      <Row gutter={[16, 16]}>
        {renderTyreField('front_tyre_left', 'Front Tyre Left', true)}
        {renderTyreField('front_tyre_right', 'Front Tyre Right', true)}
        {renderTyreField('back_tyre_left', 'Back Tyre Left', true)}
        {renderTyreField('back_tyre_right', 'Back Tyre Right', true)}
        {renderConditionalField('spare_wheels', 'Spare Wheels', yesNoOptions, true, true)}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Exterior Components */}
      <Title level={5} className='mb-3'>Exterior Components</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('front_spoiler', 'Front Spoiler', okNotOkOptions, true, true, 'Ok')}
        {renderConditionalField('front_bumper', 'Front Bumper', okNotOkOptions, true, true)}
        {renderConditionalField('grill', 'Grill', okNotOkOptions, true, true)}
        {renderConditionalField('rear_bumper', 'Rear Bumper', okNotOkOptions, true, true)}
        {renderConditionalField('rear_spoiler', 'Rear Spoiler', okNotOkOptions, true, true, 'Ok')}
        {renderConditionalField('head_light', 'Head Light', okNotOkOptions, true, true)}
        {renderConditionalField('tail_light', 'Tail Light', okNotOkOptions, true, true)}
        {renderConditionalField('fog_lamp', 'Fog Lamp', okNotOkOptions, true, true)}
        {renderConditionalField('side_mirror', 'Side Mirror', okNotOkOptions, true, true)}
        {renderConditionalField('mud_flap', 'Mud Flap', okNotOkOptions, true, true, 'Ok')}
        {renderConditionalField('windshield_glass', 'Wind Shield Glass', okNotOkOptions, true, true)}
        {renderConditionalField('wheel_cover', 'Wheel Cover', okNotOkOptions, true, true, 'Ok')}
        {renderConditionalField('weather_strip', 'Weather Strip', okNotOkOptions, true, true, 'Ok')}
        {renderConditionalField('logo_missing', 'Logo Missing', okNotOkOptions, true, true, 'Ok')}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Paint Work */}
      <Title level={5} className='mb-3'>Paint Work</Title>
      <Row gutter={[16, 16]}>
        {renderConditionalField('exterior_front_paint', 'Exterior Front Paint', paintOptions, true, true, 'Ok')}
        {renderConditionalField('exterior_left_paint', 'Exterior Left Paint', paintOptions, true, true, 'Ok')}
        {renderConditionalField('exterior_right_paint', 'Exterior Right Paint', paintOptions, true, true, 'Ok')}
        {renderConditionalField('exterior_rear_paint', 'Exterior Rear Paint', paintOptions, true, true, 'Ok')}
        {renderConditionalField('exterior_top_paint', 'Exterior Top Paint', paintOptions, true, true, 'Ok')}
      </Row>
      
      <div className='h-line'>&nbsp;</div>

      {/* Other Observations */}
      <Title level={5} className='mb-3'>Other Observations</Title>
      <Row gutter={[16, 16]}>
        {renderTextAreaField('exterior_other_observation_remarks', 'Exterior Other Observation Remarks', true)}
      </Row>
    </div>
  );
};

export default Step3MechanicalExteriorForm;

